import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationCardResponse } from '../../../directory/models/organization-card-response.model';
import { ImageService } from '../../../services/shared/image.service';

@Component({
    selector: 'app-organization-members-modal',
    template: `
        <p-dialog
            [(visible)]="visible"
            [style]="{ width: '90%', maxWidth: '800px' }"
            [header]="'organizations.memberModal.collaborators' | translate"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            [closeOnEscape]="true"
            [dismissableMask]="true"
            [appendTo]="'body'"
        >
            <div class="dialog-content">
                <ul class="list-group list-participants">
                    <li *ngFor="let profile of organization?.employees" class="list-group-item">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <div class="col-auto">
                                    <app-user-avatar
                                        [firstName]="profile.firstName"
                                        [lastName]="profile.lastName"
                                        [picture]="profile.pictureAccessLink"
                                        [routerLink]="['/directory/profile', profile.userId]"
                                    >
                                    </app-user-avatar>
                                </div>
                                <div class="d-flex flex-column ms-2">
                                    <div>{{ profile.firstName }}, {{ profile.lastName }}</div>
                                    <div>
                                        <span class="text-muted">{{ profile.jobTitle }}</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <a [routerLink]="['/directory/profile', profile.userId]" class="btn btn-primary btn-sm" (click)="hideDialog()">
                                    <em class="icon icon-preview d-sm-inline d-md-none"></em>
                                    <span class="d-none d-md-inline">{{ 'organizations.memberModal.seeProfil' | translate }}</span>
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <ng-template pTemplate="footer">
                <button type="button" class="btn btn-secondary" (click)="hideDialog()">
                    {{ 'components.button.buttonClose' | translate }}
                </button>
            </ng-template>
        </p-dialog>
    `,
    styles: [
        `
            :host ::ng-deep .p-dialog-header {
                padding: 1rem;
                border-bottom: 1px solid #e9ecef;
            }

            :host ::ng-deep .p-dialog-content {
                padding: 0;
            }

            :host ::ng-deep .p-dialog-footer {
                padding: 1rem;
                border-top: 1px solid #e9ecef;
                text-align: right;
            }

            .dialog-content {
                padding: 1rem;
            }
        `,
    ],
})
export class OrganizationMembersModalComponent {
    @Input() organization: OrganizationCardResponse;
    visible: boolean = false;

    constructor(public imageService: ImageService, private translate: TranslateService) {}

    showDialog(): void {
        this.visible = true;
    }

    hideDialog(): void {
        this.visible = false;
    }
}
